module.exports = __webpack_public_path__ + "img/tu2.b756868d.png";